module.exports = __webpack_public_path__ + "img/pana.69d6f6d2.png";